import { isCdm, isPp } from "features/cdm/constants/reviewTypes";

// The care plan is a per-review artifact. When no specific review is in hand
// (e.g. the global "Personalised Care Plan" view, or prefilling a new review
// with the previous one's goals), we resolve to the patient's most recent
// CDM/PP review. OCF reviews and deregistrations carry no care plan and are
// excluded — otherwise a later OCF would shadow the real previous care plan
// (empty carry-forward ⇒ a PP annual can't record progress on last review's goals).
export const getLatestReviewId = (reviewHistory) => {
  const programmeReviews = (reviewHistory ?? []).filter(
    (review) => isCdm(review.reviewType) || isPp(review.reviewType)
  );

  if (!programmeReviews.length) return null;

  return (
    [...programmeReviews].sort(
      (a, b) =>
        new Date(b.reviewDate ?? b.date) - new Date(a.reviewDate ?? a.date)
    )[0]?.id ?? null
  );
};
